import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';
import type { FamilyInviteLink } from 'reactApp/modules/family/family.types';

export class ProlongFamilyLinkAPICall extends APICallV4<FamilyInviteLink> {
    _method = 'family/link/prolong';
    _type: Method = 'post';
    _retriesCount = 0;
}
